// Router minimo basado en hash. Soporta un segmento variable: '#/proyecto/:id'
// matchea '#/proyecto/12' y le pasa { id: "12" } a la pagina.

export type Pagina = (
  contenedor: HTMLElement,
  params: Record<string, string>,
) => void | Promise<void>;

export interface Ruta {
  patron: string;
  titulo: string;
  render: Pagina;
  oculta?: boolean;
}

/** Devuelve los parametros si el hash matchea el patron, o null si no. */
function coincide(patron: string, hash: string): Record<string, string> | null {
  const p = patron.split("/");
  const h = hash.split("/");
  if (p.length !== h.length) return null;
  const params: Record<string, string> = {};
  for (let i = 0; i < p.length; i++) {
    if (p[i].startsWith(":")) params[p[i].slice(1)] = decodeURIComponent(h[i]);
    else if (p[i] !== h[i]) return null;
  }
  return params;
}

export function navegar(hash: string): void {
  if (location.hash === hash) render();
  else location.hash = hash;
}

let rutas: Ruta[] = [];
let contenedor: HTMLElement;

function render(): void {
  const hash = location.hash || rutas[0]?.patron || "#/";
  for (const ruta of rutas) {
    const params = coincide(ruta.patron, hash);
    if (params && contenedor) {
      contenedor.innerHTML = "";
      void ruta.render(contenedor, params);
      return;
    }
  }
  // Hash desconocido: a la primera pantalla.
  if (rutas[0]) navegar(rutas[0].patron);
}

export function iniciarRouter(_rutas: Ruta[], _contenedor: HTMLElement): void {
  rutas = _rutas;
  contenedor = _contenedor;
  window.addEventListener("hashchange", render);
  render();
}
